import validate from "/opt/build/repo/node_modules/.pnpm/nuxt@3.13.0_@parcel+watcher@2.4.1_@types+node@18.19.47_eslint@9.9.1_jiti@1.21.6__ioredis@5.4._fvjfvyr5pptjbumkl32nzpbhwq/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/opt/build/repo/node_modules/.pnpm/nuxt@3.13.0_@parcel+watcher@2.4.1_@types+node@18.19.47_eslint@9.9.1_jiti@1.21.6__ioredis@5.4._fvjfvyr5pptjbumkl32nzpbhwq/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/opt/build/repo/middleware/auth.ts"),
  "confirm-email": () => import("/opt/build/repo/middleware/confirmEmail.ts")
}